import { RuleLevel } from "interfaces/rule";
import { CellProps, Column } from "react-table";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

export interface ThresholdTableProps {
  handleEditDialog: (rule: RuleLevel) => void;
}

export const THRESHOLD_TABLE_COLUMNS = ({
  handleEditDialog
}: ThresholdTableProps): Column<RuleLevel>[] => [
  {
    Header: "Site",
    id: "site_name",
    accessor: data => data.site_name,
    disableSortBy: true
  },
  {
    Header: "Machine",
    id: "machine_name",
    accessor: data => data.machine_name ?? "N/A",
    disableSortBy: true
  },
  {
    Header: "Severity",
    id: "rule_level_type_name",
    accessor: data => data.rule_level_type_name,
    disableSortBy: true
  },
  {
    Header: "Threshold Level",
    id: "level",
    accessor: data => data.level,
    disableSortBy: true
  },
  {
    Header: "Action",
    id: "next_action_due_date",
    Cell: (cellProps: CellProps<RuleLevel>) => (
      <IconButton
        title={`Edit Threshold`}
        onClick={() => {
          handleEditDialog(cellProps.row.original);
        }}
        color="primary"
        size="large"
      >
        <EditIcon fontSize="small" />
      </IconButton>
    ),
    disableSortBy: true
  }
];
